import { render, staticRenderFns } from "./PointGmoneyCancel.vue?vue&type=template&id=412ea0c5"
import script from "./PointGmoneyCancel.vue?vue&type=script&lang=js"
export * from "./PointGmoneyCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports